import lang from '@/lang'
import { INVOICE_ANALYSIS_STATE } from '@/modules/document/utils/invoice-analysis-state'

// FLAG:useDocuAi — the badge inside the review card describes the persisted document review.
// The caller only supplies documentReviewDetails on the DocuAI review path; without those details
// the legacy receipt-state label remains untouched.
export const getReviewStatusBadgeLabel = (reviewStatus?: string | null) => {
  if (reviewStatus === INVOICE_ANALYSIS_STATE.COMPLETE) return lang.documents.invoiceAnalysisComplete
  if (reviewStatus === INVOICE_ANALYSIS_STATE.PARTIAL) return lang.documents.invoiceAnalysisPartial
  return undefined
}
